import React from 'react'
import styled from 'styled-components'

import ArrowBackSrc from '../../../../../manager/images/arrow-back.svg'

const ArrowBack = styled.img`
  height: 17.78px;
  width: 20px;
`
const ArrowBackIcon = () => (
    <ArrowBack src={ArrowBackSrc} />
)

export default ArrowBackIcon
